import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/TimeBreakdown/components/Item'
import ItemsBox from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/TimeBreakdown/components/ItemsBox'
import { Contribution } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/lib/breakdownWorkedTime'

interface Props {
  specialHoursContributions: Contribution[]
  specialHoursMinutes: number
}

const SpecialHours = ({ specialHoursContributions, specialHoursMinutes }: Props) => {
  return (
    <ItemsBox
      label={i18n.t('clock_in.sidepanel.worked_hours.special_hours.title')}
      minutes={specialHoursMinutes}
      description={i18n.t('clock_in.sidepanel.worked_hours.special_hours.description')}
      displayBreakdown={specialHoursMinutes !== 0}
    >
      {specialHoursContributions.map((contribution) => (
        <Item key={contribution.name} label={contribution.name} minutes={contribution.minutes} />
      ))}
    </ItemsBox>
  )
}

export default SpecialHours
